import {IsEmptyVar} from '../defines/common.func';
import {SimpleWord} from './simple-word.model';

export class SimpleProverb {
  id: string;
  proverb2: string;
  proverb3: string;
  meaning2: string;

  constructor(obj?: any) {
    this.id           = (obj && obj.id)           ?? null;
    this.proverb2     = (obj && obj.proverb2)     ?? null;
    this.proverb3     = (obj && obj.proverb3)     ?? null;
    this.meaning2     = (obj && obj.meaning2)     ?? null;
  }
}



export class Proverb extends SimpleProverb {
  meaning3: string;
  bookmark: boolean;
  words?: Array<SimpleWord>

  constructor(obj?: any) {
    super(obj);
    this.meaning3     = (obj && obj.meaning3)     ?? null;
    this.bookmark     = (obj && !IsEmptyVar(obj.bookmark)) ? !!obj.bookmark : false;

    if (obj?.words && Array.isArray(obj.words)) {
      this.words = new Array<SimpleWord>();
      obj.words.forEach((value: any) => this.words?.push(new SimpleWord(value)));
    }
  }
}
